import { Component } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {
  set_datapage,
  getMapStateDefault,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { Templates } from "@ora/recursos";
import {
  checkDataDirectorio,
  // seDataDirectorio,
  seDatatDocumentos,
} from "@ora/recursos/src/redux/actions/DirectoriosActions";
import { Button, Card, Section, Form } from "react-bulma-components";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from "jquery";
import dt from "datatables.net";
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo } from "helpers/Datatables";
import Swal from "sweetalert2";
import { PageLength } from "helpers/Datatables";

$.DataTable = dt;

class Config extends Component {
  state = {
    listType: [],
  };
  filter = {
    buscar: "",
  };
  table = null;
  datatable = null;

  constructor(props) {
    super(props);

    this.props.set_datapage({
      titulo: "Intranet CITES",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Config", url: "#" },
        { name: "Intranet CITES", url: "#", active: true },
      ],
    });
  }
  componentDidMount() {
    this.init();
  }
  
  init = () => {
    
  }
  onSubmit_filter = (evt) => {
    
  };
  render() {
    return (
      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
        <h1>INTRANET CITES</h1>
      </Templates.Default.BasePageRoute2>
    );
  }
}

// export default connect(null, {set_datapage})(Pais)
export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(Config);
